exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".document-header[data-v-f46e6d0c]{text-align:center}button[data-v-f46e6d0c]:disabled{cursor:not-allowed;opacity:.3}.button-containers[data-v-f46e6d0c]{display:flex;flex-direction:row-reverse}.cancel-btn-container[data-v-f46e6d0c]{flex-grow:1}@media (max-width:600px){.button-containers[data-v-f46e6d0c]{display:block;text-align:center}.cancel-btn-container[data-v-f46e6d0c]{margin-top:8px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f46e6d0c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/documents/SigningDocumentDialog.vue
// module id = 1033
// module chunks = 2